<template v-if="content.rows">
  <div class="product-page__rows">
    <div class="flex flex-wrap row--container justify-center">
      <div class="w-12/12 md:w-6/12 text-center">
        <div class="w-full px-gap2 z-10 max-w-[600px] mx-auto">
          <Markdown :source="content.heroText" />
        </div>
        <div v-if="isVGBasicCustomer && activeOffer.productKey=='VG54'">
          <Notice class="notice" noticeType="notice">
            <template v-slot:content>
              Your business does not currently leverage the full Vehicle Gateway functionality. Please contact your sales rep to upgrade or add-on to your fleet.
            </template>
          </Notice>
        </div>
        <div class="mt-3 md:mt-0 md:flex justify-center items-center md:max-w-[450px] md:max-h-[62px] mx-auto md:mb-2 ">
          <span
            class="leading-tight font-bold cursor-pointer bg-blue-default text-white md:mr-2 py-1 px-2 rounded-full text-lg w-2/12 min-w-[130px] text-center"
            :class="!(!isENT || (isENT && activeOffer.monthlyUnitPrice)) && 'md:mr-0'"
            @click="handleBuyButtonClick()"
          >
            {{ buyButtonLanguage }}
          </span>
          <Pricing v-if="shouldCustomerSeePricing && (!isENT || (isENT && activeOffer.monthlyUnitPrice))"/>
        </div>
        <div v-if="activeProductInfo.productAlert" class="product-alert">{{ activeProductInfo.productAlert }}</div>
      </div>
    </div>
    <!-- modular product page rows  -->
    <Row
      v-for="(content, index) in content.rows"
      :row="content"
      :key="index"
    />
    <!-- / modular product page rows  -->
    <div
      class="product-page__accessories"
      v-if="activeProductInfo.frequentlyBoughtTogether && activeProductInfo.frequentlyBoughtTogether.length > 0"
    >
      <FrequentlyBoughtTogether :activeProductInfo="activeProductInfo" />
    </div>
  </div>
</template>
<script>
import FrequentlyBoughtTogether from "../components/FrequentlyBoughtTogether";
import { mapGetters, mapMutations } from "vuex";
import Row from "../components/legos/Row";
import Pricing from "../components/Pricing";
import Markdown from "../components/legos/Markdown";
import { WebstoreResources } from "../../../../mixins/webstore-resources";
import SalesforceResources from "../../../../mixins/salesforce-resources";
import SegmentResources from "../../../../mixins/segment-resources";
import Notice from "../../../utils/notice";
export default {
  mixins: [
    WebstoreResources,
    SalesforceResources,
    SegmentResources,
  ],
  components: {
    FrequentlyBoughtTogether,
    Pricing,
    Row,
    Markdown,
    Notice
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      "activeProductInfo",
      "activeOfferKey",
      "isVGBasicCustomer"
    ]),

    activeOffer() {
      if (this.activeOfferKey) {
        return this.activeProductInfo.offerings[this.activeOfferKey]
      }
      else{
          return this.activeProductInfo.offerings[
            this.activeProductInfo.defaultOffering
          ]
      }
    },
  },
  methods: {
    ...mapMutations([
      "setActiveProductTab",
    ]),

    trackBuyButtonClick() {
      const properties = {
        buyButtonLocation: 'Product details page',
      }
      this.fireSegmentTrackingWithSfdcSegments("Buy Button Clicked", this.sfdcSegments, properties);
    },

    handleBuyButtonClick() {
      this.buyButtonFunctionality();
      this.trackBuyButtonClick();
    },

  }
};
</script>
<style lang="scss" scoped>
  .product-page__rows {
    margin-top: 50px;
    overflow: hidden;

    @media only screen and (min-width: 1000px) {
      margin-top: 72px;
    }
  }

  .product-page__rows ::v-deep h5 {
    line-height: 1.3 !important;
    font-size: 20px;
  }

  .product-alert {
    margin: 0 auto;
    margin-top: -10px;
    margin-bottom: 40px;
    color: #9F6000;
    font-weight: bold;
    background-color: #FEEFB3;
    padding: 20px;
    width: fit-content;
    border-radius: 5px;
  }
  
  .product-page__rows ::v-deep h5 {
    @media only screen and (min-width: 1000px) {
      margin: 0 auto;
      margin-top: 10px;
      margin-bottom: 60px;
      max-width: 440px;
    }
  }
  :deep(.notice){
    margin-top: 0px !important;
    margin-bottom: 30px;
  }
</style>